import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'story_preview',
    props: {
        id : String,
        customclick : Boolean,
        checkAccess : String,
        viewRestriction : Object,
        fromCourse : Boolean
    },

    data : function(){

        return {
            loading : false,
            story : null,
            error : null
        }

    },

    created(){
        
    },

    watch: {
        id : {
            immediate : true,
            handler : function(){
                this.load()
            }
        }
    },
    
    computed: mapState({
        auth : state => state.auth,
        canSee : function(){
            
            return !this.viewRestriction && (!this.checkAccess || this.core.user.checkFeatures([this.checkAccess]))
        }
    }),

    methods : {
        load : function(){
            this.loading = true
            this.error = null
            this.story = null

            this.core.api.stories.get(this.id).then((story) => {
                this.story = story
            }).catch(e => {
                this.error = e
            }).finally(() => {
                this.loading = false
            })
        },

        gotostory : function(){

            if(this.customclick){
                this.$emit('click')
            }
            else{
                this.$router.push('stories/' + this.id)
            }

            
        },

        playlist : function(){

            if(!this.auth) return

            this.core.cordovakit.vibration()
            this.core.vueapi.playlist({
                story : {
                    id : this.id,
                    time : 0
                }
            })
        },

        textVersion : function(){
            this.core.vueapi.storytext({
                story : this.story
            }, {
                
            })
        },
    },
}